<template>
  <div class="page-wrap">
    <div class="page-wrap-inner">
      <img
        class="page-title"
        src="https://cbgccdn.thecover.cn/@/images/20211129/1638170328811032045.png"
        alt=""
      />
      <div class="page-content">
        <slot name="default"></slot>
      </div>
    </div>
    <button class="back" @click="$emit('back')" v-if="isModal"></button>
  </div>
</template>

<script>
export default {
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  width: 100vw;
  height: 100vh;
  .back {
    position: absolute;
    right: 10px;
    top: 10px;
    border-radius: 5px;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #fff;
    //   background-color: #1e7a87;
    background-color: #2FACB1;
    background-image: url("https://cbgccdn.thecover.cn/@/images/20210528/1622187450857017362.png");
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center center;
    box-shadow: 0 2px 1px 1px #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .page-wrap-inner {
    width: 100%;
    height: 100%;
    background-image: url("https://cbgccdn.thecover.cn/@/images/20211129/1638170311224088912.jpg");
    background-size: 100% 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-top: 8vw;

  &::-webkit-scrollbar {
    height: 0;
    width: 0;
    color: transparent;
  }

    .page-title {
      width: 100%;
      // max-width: 300px;
    }
    .page-content {
      padding: 20px;
    }
  }
}
</style>